import React, { useRef, useState } from "react";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import fileToBase64 from "@/utils/fileToBase64";
import { handleApiError } from "@/utils/errorHandler";
import { updateBusiness } from "@/_actions/businessActions";
import CameraIcon from "../img/camera.svg";
import { errorClassName, outlineButtonClassName } from "../styles";

export default function UploadLogo({ clientId, logoClient, callBack }) {
  const inputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState("");

  const getFiles = async (e) => {
    const file = e.target.files[0];
    if (!file || isUploading) return;

    setIsUploading(true);
    setError("");
    try {
      const fileCoverted = await fileToBase64(file);
      const [, ...rest] = fileCoverted.split(",");

      await updateBusiness(clientId, {
        img_real_estate: {
          name: file.name,
          content_type: file.type,
          format: file.name.split(".")[name.split(".").length - 1],
          base64: rest.join(),
          originFile: file,
        },
      });
    } catch (err) {
      setError(`No se pudo actualizar el logo. ${handleApiError(err).userMessage}`);
      return;
    } finally {
      setIsUploading(false);
      // Lets the same file be selected again after an error.
      if (inputRef.current) inputRef.current.value = "";
    }
    if (callBack) {
      callBack(clientId);
    }
  };

  return (
    <div>
      <div className="flex items-start gap-4">
        <div className="flex size-20 shrink-0 items-center justify-center overflow-hidden border border-[#acbebe]/80 bg-white">
          {logoClient ? (
            <img
              src={logoClient}
              alt="Logo de la inmobiliaria"
              className="size-full object-contain"
            />
          ) : (
            <Building2 aria-hidden="true" className="size-8 text-gray-400" />
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          aria-label={isUploading ? "Subiendo logo" : "Editar logo"}
          disabled={isUploading}
          onClick={() => inputRef.current?.click()}
          className={outlineButtonClassName}
        >
          <img src={CameraIcon} alt="" width="24" height="24" />
          {isUploading ? "Subiendo…" : "Editar"}
        </Button>
        <input
          ref={inputRef}
          id="file-upload"
          name="file-upload"
          type="file"
          className="hidden"
          onChange={getFiles}
          accept="image/jpeg,image/png"
        />
      </div>
      {error ? (
        <p role="alert" className={errorClassName}>
          {error}
        </p>
      ) : null}
    </div>
  );
}

UploadLogo.defaultProps = {
  callBack: null,
};
